import math from './math';

export default (value, precision = 32) => {
  const val = Number(value);

  let bestNumerator = 1;
  let bestDenominator = 1;

  if (precision) {
    let bestRemainder = Math.abs(val - 1);

    for (let denom = 1; bestRemainder > 0 && denom <= precision; denom += 1) {
      const numer = Math.round(val * denom);
      const remainder = Math.abs(val - numer / denom);

      if (remainder < bestRemainder) {
        bestNumerator = numer;
        bestDenominator = denom;
        bestRemainder = remainder;
      }
    }
  } else {
    const f = math.fraction(val);
    bestNumerator = f.n;
    bestDenominator = f.d;
  }

  return `${bestNumerator} in ${bestDenominator}`;
};
